import SiparislerService from "../../../services/SiparislerService";

export default {
  namespaced: true,
  state: () => ({
    siparisListesi: [],
  }),
  mutations: {
      setsiparisListesi: (state, list) => {
          state.siparisListesi = list
      }
  },
  actions: {
    siparisListesi: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        SiparislerService.siparisListesi(data)
          .then((res) => {
            commit("setSiparisListesi", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};